export const OverlayFocusableSelector = [
    'button:not([disabled])',
    '[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',')

export function getOverlayFocusableElements(container: HTMLElement | undefined): HTMLElement[] {
    if (!container) {
        return []
    }

    return Array.from(container.querySelectorAll(OverlayFocusableSelector)).filter(
        (element): element is HTMLElement =>
            element instanceof HTMLElement && element.getAttribute('aria-hidden') !== 'true'
    )
}

export function focusOverlayElement(element: HTMLElement | undefined): void {
    if (element?.isConnected) {
        element.focus()
    }
}

export function containOverlayFocus(
    event: KeyboardEvent,
    container: HTMLElement | undefined
): void {
    if (event.key !== 'Tab' || !container) {
        return
    }

    const focusableElements = getOverlayFocusableElements(container)

    if (!focusableElements.length) {
        event.preventDefault()
        container.focus()
        return
    }

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]
    const activeElement = document.activeElement

    if (!container.contains(activeElement)) {
        event.preventDefault()
        const focusTarget = event.shiftKey ? lastElement : firstElement
        focusTarget.focus()
    } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
    } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
    }
}
